import React from 'react';
import PropTypes from 'prop-types';

class Removable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      className: 'removable-initial',
    };
  }

  remove() {
    this.setState({
      className: 'removable-removing',
    });

    setTimeout(() => {
      this.setState({ className: 'removable-removed' });
    }, 1500);
  }

  handleAllClickEvents = e => {
    if (e.resourceDeleteEvent) {
      this.remove();
    }
  }

  render() {
    return (
      <div className={this.state.className} onClick={this.handleAllClickEvents} >
        <div>
          { this.props.children }
        </div>
      </div>
    );
  }
}

Removable.propTypes = {
  children: PropTypes.element.isRequired,
};

export default Removable;



/** WEBPACK FOOTER **
 ** ./src/components/removable/index.js
 **/